var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpadd16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-256)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: -8.8818e-16,
    width: 16,
    height: 16,
    fill: "none",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264 0a1.0001 1.0001 0 0 0-0.70703 0.29297l-7 7a1.0001 1.0001 0 0 0 0.70703 1.707h3v6a1.0001 1.0001 0 0 0 1 1h5v-2h-2c-0.55226-5.5e-5 -0.99994-0.44774-1-1v-2c6e-5 -0.55226 0.44774-0.99994 1-1h2v-2c6e-5 -0.55226 0.44774-0.99994 1-1h2c0.55226 5.52e-5 0.99994 0.44774 1 1v1h1a1.0001 1.0001 0 0 0 0.70703-1.707l-7-7a1.0001 1.0001 0 0 0-0.70703-0.29297z",
    color: "#000000",
    fill: "#afc6e9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      InkscapeStroke: "none",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267 8v3h-3v2h3v3h2v-3h3v-2h-3v-3z",
    color: "#000000",
    fill: "#2c5aa0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      InkscapeStroke: "none",
      paintOrder: "markers stroke fill"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpadd16);
export default __webpack_public_path__ + "static/media/up.add.16.646b8c7c7f8189e1771e2880854d0425.svg";
export { ForwardRef as ReactComponent };